import moment, { Moment } from 'moment-timezone';
import { useState } from 'react';
import { useInterval } from 'react-use';

import { getNextQuarter } from './getNextQuarter';

const quarterHourInMs = 15 * 60 * 1000;

/**
 * A hook for getting the next closest quarter of the hour time while updating
 * it each quarter.
 */
export const useNextQuarter = (): Moment => {
  const [nextQuarter, setNextQuarter] = useState(getNextQuarter());
  const [intervalTime, setIntervalTime] = useState(
    quarterHourInMs -
      (moment().startOf('s').toDate().getTime() % quarterHourInMs),
  );

  useInterval(() => {
    setNextQuarter(getNextQuarter());
    setIntervalTime(quarterHourInMs);
  }, intervalTime);

  return nextQuarter;
};
